<template>
  <div class="flex space-x-1">
    <transition name="fade" mode="out-in" duration="200">
      <div v-if="selected_item_clone">
        <AIPrompt :selected-item="selected_item" />
      </div>
    </transition>

    <div class="mt-auto">
      <AIMenu v-model:selected-item="selected_item" />
    </div>
  </div>
</template>

<script>
import AIMenu from "./AIMenu"
import AIPrompt from "./AIPrompt"
export default {
  components: { AIMenu, AIPrompt },
  props: {},
  emits: [],
  data() {
    return {
      selected_item_clone: null,
      selected_item: null
    }
  },
  watch: {
    selected_item: {
      deep: true,
      handler() {
        this.selected_item_clone = this.selected_item
      }
    }
  },

  created() {},

  methods: {}
}
</script>
